module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/signme_signup-2e1df4d381dae3e25da3cfff3fcee39f.svg";